



























import {
  defineComponent, ref,
} from '@vue/composition-api';
import { useDrift } from '~/composables/useDrift';

export default defineComponent({
  name: 'DriftFacade',
  setup() {
    const loading = ref(false);

    const {
      loadDrift, openChat, isDriftLoaded, popUpText,
    } = useDrift();

    function loadAndOpenChat() {
      loading.value = true;
      loadDrift();
      openChat();
    }

    return {
      popUpText,
      loadAndOpenChat,
      loading,
      isDriftLoaded,
    };
  },
});
